"use strict";
var CoverageCartTripDetailsViewModel = (function () {
    function CoverageCartTripDetailsViewModel() {
    }
    return CoverageCartTripDetailsViewModel;
}());
exports.CoverageCartTripDetailsViewModel = CoverageCartTripDetailsViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/coverage-cart/coverage-cart-trip-details-view.model.js